module.exports = __webpack_public_path__ + "static/cursor-57820d726544935caf550cf3a0679b97.png";